import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.scrollHandler = this.throttle(() => {
      this.updateVisibility()
    }, 16)

    window.addEventListener('scroll', this.scrollHandler)
  }

  disconnect() {
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler)
    }
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  updateVisibility() {
    if (!this.hasButtonTarget) return

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop

    if (scrollTop > 400) {
      this.buttonTarget.classList.add('visible')
    } else {
      this.buttonTarget.classList.remove('visible')
    }
  }

  throttle(func, limit) {
    let inThrottle
    return function(...args) {
      if (!inThrottle) {
        func.apply(this, args)
        inThrottle = true
        setTimeout(() => inThrottle = false, limit)
      }
    }
  }
}
